import { defineMessages } from 'react-intl';

export default defineMessages({
    whereDidThisHappen: {
        id: 'fnol.common.directives.loss-location.Where did this happen?',
        defaultMessage: 'Where did this happen?'
    },
    lossLocation: {
        id: 'fnol.common.directives.loss-location.Location',
        defaultMessage: 'Location'
    },
    fnolUseMyPolicyAddress: {
        id: 'fnol.common.directives.loss-location.Select address from Policy',
        defaultMessage: 'Select address from Policy'
    },
    fnolSpecifyFullAddress: {
        id: 'fnol.common.directives.loss-location.Specify full address manually',
        defaultMessage: 'Address of loss'
    },
    lossLocationDesc: {
        id: 'fnol.common.directives.loss-location.Loss location description',
        defaultMessage: 'Loss location description'
    },
    fnolLocationMap: {
        id: 'fnol.common.directives.loss-location.Choose incident location on the map',
        defaultMessage: 'Choose incident location on the map'
    },
    fnolSelectAddress: {
        id: 'fnol.common.directives.loss-location.Select Address',
        defaultMessage: 'Select Address'
    },
    fnolChooseAddress: {
        id: 'fnol.common.directives.loss-location.-- Choose Address --',
        defaultMessage: '-- Choose Address --'
    },
    fnolProvideAddress: {
        id: 'fnol.common.directives.loss-location.Please provide an address.',
        defaultMessage: 'Please provide an address.'
    },
    fnolMapLocation: {
        id: 'fnol.common.directives.loss-location.Click anywhere on the map to set a location or drag the pin to adjust it.',
        defaultMessage: 'Click anywhere on the map to set a location or drag the pin to adjust it.'
    }
});
